import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useTabelaHorariosOutletContext } from 'pages/TabelaHorario'
import { useMemo } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import {
    TabelaHorarios,
    UpdateTabelaHorariosSchema,
    tabelaHorarios,
} from 'service/api'
import { toast } from 'sonner'
import { CanSubmitProvider, useCanSubmit } from '../context/CanSubmitContext'
import FormTabelaHorario from '../forms/FormTabelaHorario'

function EditarTabelaHorariosContent() {
    const { id } = useParams()
    const { data } = useTabelaHorariosOutletContext()
    const tabela = data.find(item => item.id === Number(id))
    const { canSubmit } = useCanSubmit()
    const { mutateAsync, isLoading } = tabelaHorarios.mutations.useUpdate({
        invalidateQuery: true,
    })

    const MemoizedForm = useMemo(() => <FormTabelaHorario />, [tabela])

    if (!tabela) return null

    const handleSubmit: SubmitHandler<TabelaHorarios> = data =>
        mutateAsync(
            {
                ...data,
                previewEspelho: data.previewEspelho
                    ? JSON.stringify(data.previewEspelho)
                    : undefined,
            },
            {
                onSuccess: () => {
                    toast.success('Tabela atualizada com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            height="auto"
            width="62rem"
            loading={isLoading}
            onSubmit={handleSubmit}
            defaultValues={tabela}
            schema={UpdateTabelaHorariosSchema}
            open={hasPermission(['update', 'TabelaDeHorários'])}
        >
            <Dialog.Title>Editar tabela de horários</Dialog.Title>
            <Dialog.Content dividers>{MemoizedForm}</Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton
                    closeOnSubmit
                    disabled={!canSubmit}
                />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default function EditarTabelaHorarios() {
    return (
        <CanSubmitProvider>
            <EditarTabelaHorariosContent />
        </CanSubmitProvider>
    )
}
